import { useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@karma/components';
import { PayPalIcon } from '@karma/components/icons';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import { usePayPalButtons } from 'hooks/usePayPal';

const ModalBodyPaypalConnect = () => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const payPalButtons = usePayPalButtons();

  return (
    <Stack direction="column" spacing={20}>
      <PayPalIcon width={60} height={60} />
      <Typography variant="h3">{t('app:connectToPayPalToCashOut')}</Typography>
      <Button
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.CONNECT_WITH_PAY_PAL}
        onClick={payPalButtons.connect.handler}
        size="medium"
        fullWidth
      >
        {t('app:connectWithPayPal')}
      </Button>
    </Stack>
  );
};

export default ModalBodyPaypalConnect;
